import { Card } from 'nhsuk-react-components';
import { Link } from 'react-router-dom';
import { CampaignConfig } from 'schemas/CampaignConfig.schema.ts';
import { CampaignTemplate } from 'schemas/CampaignTemplates.schema.ts';
import { YYYYMMDDToHumanReadable } from 'utils/formattingUtils';
import useCampaignNavigate from 'hooks/useCampaignNavigate';
import { getCampaignContent } from 'utils/contentUtils';

interface CampaignPageHeaderProps {
    campaign: CampaignConfig,
    title?: string,
    showLink?: boolean,
    template?: CampaignTemplate,
}

function CampaignPageHeader({
  campaign,
  title = '',
  showLink = true,
  template,
}: CampaignPageHeaderProps) {
  const { getCampaignPathFor } = useCampaignNavigate();
  const campaignContent = getCampaignContent(campaign.CampaignConfig?.Type);

  return (
    <Card>
      <>
        <h1 role="main" id="maincontent" className="nhsuk-heading-l nhsuk-u-margin-top-0 nhsuk-u-margin-bottom-3">
          {showLink && (title || (campaign.CampaignConfig?.Name && campaign.CampaignConfig.ID)) ? (
            <Link to={getCampaignPathFor('summary')}>{title || campaign.CampaignConfig.Name}</Link>
          ) : (
            title || campaign.CampaignConfig.Name || 'Set campaign details'
          )}
        </h1>

        {campaign?.CampaignConfig?.StartDate && template?.['CampaignConfig.StartDate.header.display'] !== 'hidden' && (
          <p className="nhsuk-u-margin-bottom-0">
            {campaignContent.startDateLabel}
            :
            {' '}
            {YYYYMMDDToHumanReadable(campaign.CampaignConfig.StartDate)}
          </p>
        )}
        {campaign?.CampaignConfig?.EndDate && template?.['CampaignConfig.EndDate.header.display'] !== 'hidden' && (
          <p className="nhsuk-u-margin-bottom-0">
            {campaignContent.endDateLabel}
            :
            {' '}
            {YYYYMMDDToHumanReadable(campaign.CampaignConfig.EndDate)}
          </p>
        )}
      </>
    </Card>
  );
}

export default CampaignPageHeader;
